import { LayerDefinition } from './types';

export const lightningDefinition: LayerDefinition = {
  id: 'lightning',
  name: 'Lightning Hazard Index',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '⚡',
  description: 'Convective storm lightning probability & flash density forecast. Shows area where conditions will be favorable for lightning.',
  sourceModels: ['hrrr', 'rrfs', 'ecmwf', 'gfs', 'MRMS NLDN (Obs)'],
  outputModels: ['Lightning risk .pmtiles per model', 'Real-time MRMS flash density'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default lightningDefinition;
